import { useAppTranslation, useBackToShop } from "@/utils";
import { CloseCircleFilled } from "@payping/icons";
import { Button, Flex, Typography, theme } from "@payping/web-components";
import PayGetOrderLayout from "../Layout";

interface BadProps {
  description: string;
}

const PayGetOrderCreditScoreBad = (props: BadProps) => {
  const { t } = useAppTranslation();

  const { token } = theme.useToken();
  const { backToShop, shopName } = useBackToShop();

  return (
    <PayGetOrderLayout showHeaders currentStepError>
      <Flex vertical className="tw:h-full tw:w-full tw:px-4! tw:pb-4! tw:pt-6!" gap={"middle"} align="center">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />

        <Flex vertical gap={"small"} align="center" className="tw:mt-5! tw:text-center">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {t("pay.getOrder.steps.creditScore.badTitle")}
          </Typography.Title>
          <Typography.Paragraph className="tw:m-0!" type="secondary">
            {t("pay.getOrder.steps.creditScore.badContent")}
          </Typography.Paragraph>
        </Flex>
        <Flex
          className="tw:mt-2! tw:w-full tw:p-4!"
          justify="space-between"
          align="center"
          style={{ background: token.colorBgLayout }}
        >
          <Typography.Text>{t("pay.getOrder.steps.creditScore.creditDescription")}</Typography.Text>
          <Typography.Text type="secondary">{props.description}</Typography.Text>
        </Flex>

        <Flex vertical align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
          <Flex
            className="tw:mt-8! tw:w-full tw:rounded-lg tw:border tw:border-solid tw:border-color-border tw:p-4!"
            vertical
            gap={"small"}
          >
            <Typography.Text className="tw:font-semibold!">
              {t("pay.getOrder.steps.creditScore.standard.title")}
            </Typography.Text>
            <ul
              className="custom-list"
              style={{
                listStyleType: "square",
              }}
            >
              {(t("pay.getOrder.steps.creditScore.standard.list", { returnObjects: true }) as any[]).map(
                (item, index) => (
                  <li key={index}>
                    <Typography.Text type="secondary">{item}</Typography.Text>
                  </li>
                ),
              )}
            </ul>
          </Flex>
          <Button
            type="primary"
            block
            onClick={() => {
              backToShop();
            }}
          >
            {t("pay.returnTo", { name: shopName })}
          </Button>
        </Flex>
      </Flex>
    </PayGetOrderLayout>
  );
};

export default PayGetOrderCreditScoreBad;
